"use strict";const t=require("styled-components").css`
    &.DXTooltip {
        position: relative;
        display: inline-block;

        .DXTooltip-trigger {
            display: inline-block;
            background: transparent;
            border: none;
            padding: 0;
            vertical-align: middle;
            outline: none;
            cursor: pointer;

            svg {
                * {
                    transition: all 0.2s ease-in-out;
                }
            }
        }

        .DXTooltip-content {
            padding: 10px;
            position: absolute;
            width: 250px;
            z-index: 1000;
            background: ${({theme:t,color:o})=>o||t.colors.primary.default};
            left: 50%;
            margin-bottom: 1rem;
            transition: all 0.2s ease-in-out;
            color: ${({theme:t})=>t.colors.common.light};
            ${({location:t})=>"below"===t?"\n                            top: calc(100% + 11px);\n                        ":"right"===t?"bottom: 100%; left: -80px; border-radius: 4px;":"\n                            bottom: 100%;\n                        "}

            > * {
                &:first-of-type {
                    margin-top: 0;
                }

                &:nth-last-child(2) {
                    margin-bottom: 0;
                }
            }
        }

        .DXTooltip-arrow {
            display: block;
            width: 0;
            height: 0;
            z-index: 1001;
            position: absolute;
            left: calc(50% - 10px);
            transition: all 0.2s ease-in-out;
            ${({location:t,theme:o,color:r})=>"below"===t?`\n        border-left: 10px solid transparent;\n        border-right: 10px solid transparent;\n        border-bottom: 11px solid ${r||o.colors.primary.default};\n        bottom: 100%;\n      `:"right"===t?`left: calc(225px - 10px);\n                    border-left: 10px solid transparent;\n        border-right: 10px solid transparent;\n        border-top: 11px solid ${r||o.colors.primary.default};\n        top: 100%;`:`\n        border-left: 10px solid transparent;\n        border-right: 10px solid transparent;\n        border-top: 11px solid ${r||o.colors.primary.default};\n        top: 100%;\n      `}

            &::after {
                display: block;
                content: '';
                position: absolute;
                height: 0;
                width: 0;
                left: -10px;
                bottom: 1px;
                border-left: 10px solid transparent;
                border-right: 10px solid transparent;
            }
        }

        &--open {
            .DXTooltip-content {
                animation: animateIn ease-in-out 0.2s forwards;
            }
        }

        &--closed {
            .DXTooltip-content {
                animation: animateOut ease-in-out 0.2s forwards;
            }
        }

        @keyframes animateIn {
            0% {
                opacity: 0;
                transform: translate3d(
                    -50%,
                    ${({location:t})=>"below"===t?"10px":"-10px"},
                    0
                );
            }
            100% {
                opacity: 1;
                transform: translateX(-50%);
            }
        }

        @keyframes animateOut {
            0% {
                opacity: 1;
                transform: translateX(-50%);
            }
            100% {
                opacity: 0;
                transform: translate3d(
                    -50%,
                    ${({location:t})=>"below"===t?"10px":"-10px"},
                    0
                );
            }
        }
    }
`;module.exports=t;
//# sourceMappingURL=styles.js.map
